import { useEffect } from 'react';

// This hook is used to set custom CSS property variable for vh value. It's needed to overcome the iOS issue
// with toolbars, as general CSS vh value does not subtract them. Here we take only inner height (visible page height).
function useInnerViewportHeight() {
  useEffect(() => {
    const vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }, []);
}

export default useInnerViewportHeight;
